import { render } from "./PriceRulesEditor.vue?vue&type=template&id=37586d9f"
import script from "./PriceRulesEditor.vue?vue&type=script&lang=js"
export * from "./PriceRulesEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__